import { motion } from "framer-motion";
import { HeartHandshake, ShieldCheck, Clock3, Users } from "lucide-react";

const PROMISES = [
  {
    icon: HeartHandshake,
    title: "Dignity, first.",
    desc:
      "Every visit begins with respect for the life your loved one has built. Routines, preferences, pace — all theirs, always.",
  },
  {
    icon: Users,
    title: "Caregivers who stay.",
    desc:
      "Low caregiver turnover means your family builds a real relationship — not a rotation of strangers.",
  },
  {
    icon: ShieldCheck,
    title: "Vetted, insured, bonded.",
    desc:
      "Multi-step background checks, in-person interviews, continuing training, and full liability coverage.",
  },
  {
    icon: Clock3,
    title: "Reachable, always.",
    desc:
      "A real human on the line — days, nights, weekends — whenever something changes.",
  },
];

export default function Promise() {
  return (
    <section
      id="promise"
      data-testid="care-promise"
      className="py-24 md:py-32 bg-[#E6EAE3] border-y border-[#D5DACF]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <span className="eyebrow">Our promise</span>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl tracking-tight mt-5 leading-[1.03] text-[#1A2621]">
            Four quiet commitments
            <span className="italic text-[#284A3B]"> we don’t compromise on.</span>
          </h2>
        </div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.08 } },
          }}
          className="mt-14 grid md:grid-cols-2 gap-6 md:gap-8"
        >
          {PROMISES.map((p) => {
            const Icon = p.icon;
            return (
              <motion.div
                key={p.title}
                variants={{
                  hidden: { opacity: 0, y: 24 },
                  show: {
                    opacity: 1,
                    y: 0,
                    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
                  },
                }}
                className="relative bg-[#FDFBF7] rounded-2xl border border-[#D5DACF] p-8 md:p-10 transition-all hover:-translate-y-1 hover:shadow-md"
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-full bg-[#284A3B] text-[#FDFBF7] flex items-center justify-center">
                    <Icon size={20} />
                  </div>
                </div>
                <h3 className="font-serif-display text-2xl md:text-3xl mt-8 text-[#1A2621] leading-snug">
                  {p.title}
                </h3>
                <p className="mt-4 text-[#4A5D54] leading-relaxed">{p.desc}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
